export default function handleFloat({ oldValue, newValue }) {
    if (isNaN(newValue) == false) {
        return parseFloat(newValue)
    }
    return oldValue
}